<div class="card" data-cy="card">
  <h3 data-cy="chart-title">{{ chartTitle }}</h3>
  <canvas
    baseChart
    [data]="barChartData"
    [options]="barChartOptions"
    chartType="bar"
    data-cy="bar-chart"
  ></canvas>
</div>
<div class="custom-legend" data-cy="custom-legend">
  <span class="legend-icon" data-cy="legend-icon"></span>
  <span class="legend-label" data-cy="legend-label">Quantidade de cotas</span>
</div>